import { Input, VDBText } from "@components/atoms";
import CountryCodeDropdownPicker from "@components/atoms/CountryCodePickerWeb";
import Spacer from "@components/atoms/Spacer";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React from "react";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { Keyboard, Platform, ScrollView } from "react-native";
import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";
type AskSupplierFormProps = {
  setIsCommentsValid: any;
  theme: any;
  t: any;
  isGuest: boolean;
  control: any;
  countryCode: string;
  setCountyCode: any;
  askSupplier: any;
  fromReviewPage?: boolean;
};

const AskSupplierForm = ({
  setIsCommentsValid,
  theme,
  t,
  isGuest,
  control,
  countryCode,
  setCountyCode,
  askSupplier,
  fromReviewPage,
}: AskSupplierFormProps) => {
  const [openDrop, setOpenDropDown] = useState(false);
  const typography = useTypographyStore();
  const validateComments = (value: string) => {
    if (value.trim().length > 0) {
      setIsCommentsValid(true);
    } else {
      setIsCommentsValid(false);
    }
  };
  const handleCountrySelect = () => {
    setOpenDropDown(false);
  };
  return (
    <ScrollView
      keyboardShouldPersistTaps={"handled"}
      automaticallyAdjustKeyboardInsets={true}
      contentContainerStyle={{ flexGrow: 1 }}
    >
      <ParentContainer>
        <Spacer
          size={!theme.isLargeScreen ? SpaceType.large : SpaceType.Extra}
        />
        <StyledContainer>
          <VDBText type={typography["Body-M"]} color={theme["core-05"]}>
            {t("askSupplier.screenText.line1.text")}
          </VDBText>
          <Spacer
            size={theme.isLargeScreen ? SpaceType.large : SpaceType.Double}
          />
          {isGuest && !fromReviewPage && (
            <>
              <Controller
                control={control}
                render={({
                  field: { onChange, onBlur, value },
                  formState: { errors },
                }) => (
                  <Input
                    inputLabel={t("askSupplier.input.name.placeholder.text")}
                    leftIcon={undefined}
                    hideIconContainer={true}
                    placeholder={t("askSupplier.input.name.placeholder.text")}
                    onBlur={() => {
                      onBlur();
                      if (!value) {
                        control.setError("username", {
                          type: "required",
                          message: t(
                            "contactUs.input.validation.required.text"
                          ),
                        });
                      }
                    }}
                    onChangeText={(text) => {
                      onChange(text);
                      if (text.trim() !== "") {
                        control.setError("username", {
                          type: "required",
                          message: t(""),
                        });
                      }
                    }}
                    value={value}
                    error={errors?.username?.message as string}
                  />
                )}
                name="username"
              />
              <Spacer size={SpaceType.Double} />
              <Controller
                control={control}
                render={({
                  field: { onChange, onBlur, value },
                  formState: { errors },
                }) => (
                  <Input
                    inputLabel={t("askSupplier.input.email.placeholder.text")}
                    leftIcon={undefined}
                    hideIconContainer={true}
                    placeholder={t("askSupplier.input.email.placeholder.text")}
                    onBlur={() => {
                      onBlur();
                      if (!value) {
                        control.setError("email", {
                          type: "required",
                          message: t(
                            "contactUs.input.validation.required.text"
                          ),
                        });
                      } else {
                        const regex =
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        if (!regex.test(value)) {
                          control.setError("email", {
                            type: "pattern",
                            message: t("contactUs.input.validation.email.text"),
                          });
                        } else {
                          control.setError("email", {
                            type: "required",
                            message: t(""),
                          });
                        }
                      }
                    }}
                    onChangeText={(text) => {
                      onChange(text);
                    }}
                    value={value}
                    error={errors?.email?.message as string}
                  />
                )}
                name="email"
              />
              <Spacer size={SpaceType.Double} />
              <ContactNumber>
                <CountryCodeView isOpen={openDrop}>
                  <CountryCodeDropdownPicker
                    selected={countryCode}
                    setSelected={(value) => {
                      setCountyCode(value);
                    }}
                    setCountryDetails={handleCountrySelect}
                    pickerIsOpen={setOpenDropDown}
                    isGuest={isGuest}
                  />
                </CountryCodeView>
                {!openDrop && (
                  <>
                    <Spacer size={SpaceType.Basic} />
                    <PhoneNumberView>
                      <Controller
                        control={control}
                        render={({
                          field: { onChange, onBlur, value },
                          formState: { errors },
                        }) => (
                          <Input
                            inputLabel={t(
                              "askSupplier.input.number.placeholder.text"
                            )}
                            placeholder={t(
                              "askSupplier.input.number.placeholder.text"
                            )}
                            leftIcon={undefined}
                            hideIconContainer={true}
                            onBlur={() => {
                              onBlur();
                              if (!value) {
                                control.setError("phoneNumber", {
                                  type: "required",
                                  message: t(
                                    "contactUs.input.validation.required.text"
                                  ),
                                });
                              }
                            }}
                            onChangeText={(text) => {
                              onChange(text);
                              if (text.trim() !== "") {
                                control.setError("phoneNumber", {
                                  type: "required",
                                  message: t(""),
                                });
                              }
                            }}
                            value={value}
                            error={errors?.phoneNumber?.message as string}
                            keyboardType="number-pad"
                          />
                        )}
                        name="phoneNumber"
                      />
                    </PhoneNumberView>
                  </>
                )}
              </ContactNumber>
              <Spacer size={SpaceType.Double} />{" "}
            </>
          )}
          <Controller
            control={control}
            render={({
              field: { onChange, onBlur, value },
              formState: { errors },
            }) => (
              <Input
                inputLabel={t("askSupplier.input.placeholder.text")}
                placeholder={t("askSupplier.input.placeholder.text")}
                leftIcon={undefined}
                hideIconContainer={true}
                onBlur={onBlur}
                onChangeText={(text) => {
                  onChange(text);
                  validateComments(text);
                }}
                value={value}
                error={errors?.comments?.message as string}
                multiline={true}
                disabled={askSupplier.isLoading}
                blurOnSubmit={true}
                onSubmitEditing={() => {
                  Keyboard.dismiss();
                }}
                keyboardType="default"
                returnKeyType="done"
              />
            )}
            name="comments"
          />
        </StyledContainer>
        <Spacer size={SpaceType.Big} />
      </ParentContainer>
    </ScrollView>
  );
};

const ParentContainer = styled.View`
  ${({ theme }: { theme: DefaultTheme }) =>
    !theme.isLargeScreen &&
    Platform.OS !== "web" &&
    css`
      min-height: 450px;
    `}
`;

const StyledContainer = styled.View`
  padding-left: ${SpaceType.ExtraSmall}px;
  padding-right: ${SpaceType.ExtraSmall}px;
`;

const ContactNumber = styled.View`
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;
const CountryCodeView = styled.View<{
  isOpen: boolean;
}>`
  justify-content: flex-start;
  ${({ isOpen, theme }: { isOpen: boolean; theme: DefaultTheme }) =>
    isOpen &&
    theme.isLargeScreen &&
    css`
      flex: 1;
    `}
`;

const PhoneNumberView = styled.View`
  flex: 1;
  justify-content: flex-start;
  margin-left: 8px;
`;

export default AskSupplierForm;
